import '../sass/sale-gallery.scss';

(() => {
    const $saleGalleryBlocks = document.querySelectorAll('.sale-gallery');

    if (!$saleGalleryBlocks) return;

    $saleGalleryBlocks.forEach($saleGalleryBlock => {
        const $carousel = $saleGalleryBlock.querySelector('.sale-gallery__carousel');
        const $carouselControlsPrev = $saleGalleryBlock.querySelector('.sale-gallery__carousel-controls-prev');
        const $carouselControlsNext = $saleGalleryBlock.querySelector('.sale-gallery__carousel-controls-next');
        const $videoPlayers = $saleGalleryBlock.querySelectorAll('.sale-gallery__slide-video-player');

        const initCarousel = () => {
            if (!$carousel) return;

            new Swiper($carousel, {
                slidesPerView: 'auto',
                loop: true,
                loopAdditionalSlides: 100,
                centeredSlides: true,
                navigation: {
                    nextEl: $carouselControlsNext,
                    prevEl: $carouselControlsPrev,
                },
            });
        };

        const initVideoPlayers = () => {
            if (!$videoPlayers) return;

            $videoPlayers.forEach($videoPlayer => {
                new Plyr($videoPlayer);
            })
        };

        initCarousel();
        initVideoPlayers();
    });
})();
